import React from 'react';


const RebootModal = ({ device, onClose, onConfirm, isSubmitting }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Confirm Reboot</h2>
        <p>
          Are you sure you want to reboot device{' '}
          <strong>{device.serial_number}</strong>?
        </p>
        <p>The device will be temporarily unavailable.</p>
        <div className="modal-actions">
          <button
            type="button"
            onClick={onClose}
            className="button button-secondary"
          >
            Cancel
          </button>
           <button
                type="button"
                onClick={onConfirm}
                className="button action-button"
                style={{ backgroundColor: '#DC2626' }}
                disabled={isSubmitting} // Disable button when submitting
            >
                {isSubmitting ? 'Rebooting...' : 'Yes, Reboot'}
            </button>
        </div>
      </div>
    </div>
    
  );
};


export default RebootModal;